import React, { useMemo } from 'react';

import { FormattedMessage } from 'react-intl';

import { useGetYouthMeritBadgesQuery } from '@modules/youthProfile/api';
import YouthAdvancementsCard from '@shared/components/YouthAdvancementsCard';
import type { YouthAdvancementItem } from '@shared/components/YouthAdvancementsCard/types';
import { advancementTypes } from '@shared/constants';

interface YouthMeritBadgesProps {
  /** Scoutbook user id from the route */
  userId?: string;
}

/** The youth's merit badges. View More is off for now; only ranks have a details page */
export default function YouthMeritBadges(props: YouthMeritBadgesProps) {
  const { userId } = props;

  const { data, isFetching } = useGetYouthMeritBadgesQuery(
    // Same args the youthProfile module uses, so both read one cache entry
    { userId: userId as string, params: { status: 'all' } },
    { skip: !userId },
  );

  const items = useMemo<YouthAdvancementItem[]>(
    () =>
      (data ?? []).map(meritBadge => ({
        ...meritBadge,
        id: meritBadge.id,
        imageUrl: meritBadge.imageUrl100,
        advancementType: advancementTypes.MERIT_BADGES,
        meritBadge,
      })),
    [data],
  );

  return (
    <YouthAdvancementsCard
      title={
        <FormattedMessage id="shared.AdvancementType.meritBadges.plural" />
      }
      items={items}
      loading={isFetching}
    />
  );
}
